import type { CodeCategoryNode } from "@longjie/shared";
import { CodeCategoryTree } from "./CodeCategoryBrowser";

/** The warehouse category tree is shared by every product-selection surface. */
export function ProductCategoryFilter({ nodes, legacyCategories = [], value, onChange,
  isAdmin = false, onEditCategory, disabled = false, showSearch = true, allProductsInToolbar = true }: {
  nodes: CodeCategoryNode[];
  legacyCategories?: Array<{ id: string; name: string; productCount?: number; active?: boolean }>;
  value: string;
  onChange: (value: string, keepOpen?: boolean) => void;
  isAdmin?: boolean;
  onEditCategory?: (node: CodeCategoryNode) => void;
  disabled?: boolean;
  showSearch?: boolean;
  allProductsInToolbar?: boolean;
}) {
  const legacyOptions = <div className="product-category-legacy" role="group" aria-label="原分类名称分组">
    {legacyCategories.map((category) => <button key={category.id} type="button"
      className={`category-navigation-all${value === category.id ? " active" : ""}`}
      aria-pressed={value === category.id} disabled={disabled} onClick={() => onChange(category.id, true)}>
      {category.name}{category.productCount === undefined ? "" : `（${category.productCount}）`}{category.active === false ? "（已停用）" : ""}
    </button>)}
  </div>;
  const allProductsButton = <button type="button" className={`category-navigation-all${!value || value === "all" ? " active" : ""}`}
    aria-pressed={!value || value === "all"} disabled={disabled} onClick={() => onChange("", true)}>全部商品</button>;
  return <>
    {(!allProductsInToolbar || nodes.length === 0) && allProductsButton}
    {nodes.length > 0 && <CodeCategoryTree nodes={nodes} selectedPrefix={value.startsWith("code:") ? value.slice(5) : ""}
      onSelectCategory={(node) => onChange(`code:${node.prefix}`, true)} isAdmin={isAdmin}
      {...(onEditCategory ? { onEditCategory } : {})} disabled={disabled} showSearch={showSearch}
      {...(allProductsInToolbar ? { toolbarStart: allProductsButton } : {})} />}
    {value.startsWith("code:") && !nodes.some((node) => `code:${node.prefix}` === value) && <div className="code-category-select__missing" role="status">
      <span>当前分类路径 {value.slice(5).match(/.{2}/g)?.join(" / ")} 已无可用商品。</span>
      <button type="button" disabled={disabled} onClick={() => onChange("", true)}>清除分类筛选</button>
    </div>}
    {legacyCategories.length > 0 && (nodes.length > 0
      ? <details className="code-category-legacy" open={Boolean(value && value !== "all" && !value.startsWith("code:"))}>
        <summary>按原分类名称分组筛选</summary>{legacyOptions}
      </details> : legacyOptions)}
  </>;
}
